<div class="row">
  <h2 class="col-lg-12 center" mat-dialog-title>Previsualización</h2>
  </div>
  <mat-dialog-content style="min-width: 850px; min-height: auto; overflow: hidden;">

    <div class="modal-body" style="padding: 0px;" width="100%">
      <pdf-viewer [src]="pdfSrc"
      style="width:100%;height:80vh;"
      [render-text]="true"
      (after-load-complete)="callBackFn($event)"
      (error)="onError($event)"
      [show-all]="true">
      
      >
          <div>Loading...</div>
    </pdf-viewer>

  </div>
  </mat-dialog-content>
  <mat-dialog-actions style="overflow: hidden;">
    <button mat-flat-button color="primary" [mat-dialog-close]="true">Cerrar</button>
    <button mat-flat-button color="primary" (click)="download()">Descargar</button>
  </mat-dialog-actions>